import Axios from 'axios';

import {
	ALL_LANGUAGES_LOADING,
	ALL_LANGUAGES_GET,
	ALL_LANGUAGES_ERROR
} from './types';

export const get_all_languages = () => dispatch => {
	dispatch({
		type: ALL_LANGUAGES_LOADING,
		payload: true
	});
	
	let url = process.env.REACT_APP_SERVER_URL + '/api/utils/languages';

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: ALL_LANGUAGES_GET,
			payload: res.data
		});
		dispatch({
			type: ALL_LANGUAGES_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ALL_LANGUAGES_ERROR,
			payload: { type: 'all_languages', msg: err.message }
		});
		dispatch({
			type: ALL_LANGUAGES_LOADING,
			payload: false
		});
	})
}
